import { Typography, Stack } from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import sampleBar from "../assets/sample bar.PNG";

const BarReportInstructions = ({ languageId }) => {
  return (
    <Box sx={{ margin: 3 }}>
      <Typography variant="h6" component="div">
        {languageId === 2 ? "結果長條圖解讀：" : "Interpreting the result bars:"}
      </Typography>
      <Stack direction="row" justifyContent="space-between">
        <img
          src={sampleBar}
          alt=" showing an example bar graph"
          style={{ width: "25%", height: "35%" }}
        />
        <Box sx={{ pl: "5vw" }}>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? "每個長條圖顯示了您的孩子在每個方面與同齡人相比的表現。" : `
              Each bar shows your child's performance in each strand compared to
              their peers.
            `}
          </Typography>
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? "圖表中以黑色箭頭表示孩子的位置。" : "Your child's position on the graph is denoted by a black arrow."}
          </Typography>
          <br />
          <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
            {languageId === 2 ? "此長條圖分為四個部分，分別代表不同比例的學生：" : `
              The bar is split into four parts which group a percentage of
              students:
            `}
          </Typography>
          <ol>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? `
                  成績處於測試學生中後50%的學生。所有參加測驗的學生中，有一半的成績都在這個範圍內。
                ` : `
                  Students who performed within the lowest 50% of students tested.
                  Half of all students who sat the test performed in this range.
                `}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? `
                  成績優於 50% 的受測學生，但低於前 25% 的受測學生。
                ` : `
                  Students who performed better than 50% of students tested, but
                  lower than the top 25% of students.
                `}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? `
                  成績排在前 15% 的學生，其表現優於參加考試的後 75% 的學生，但低於前 10% 的學生。
                ` : `
                  Students who are in the 15% bar performed better than the lowest
                  75% of students who sat the test, but lower than the top 10% of
                  students.
                `}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" component="div" sx={{ fontSize: 20 }}>
                {languageId === 2 ? `
                  成績排在前 10% 的學生，其表現優於參加考試的 90% 的學生，並且位列參加考試的前 10% 的學生之列。
                ` : `
                  Students who are in the 10% bar performed better than 90% of
                  students who sat the test and are in the top 10% of students who
                  sat the test.
                `}
              </Typography>
            </li>
          </ol>
        </Box>
      </Stack>
    </Box>
  );
};

export default BarReportInstructions;
